"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * Map external props and an internal state to a component that store that internal state and renders the given inner component
 * @param getProps Get object props given internal state
 * @param getInitialState Gets the initial state
 */
function mapState(getProps, getInitialState) {
    return function (Component) {
        var ret = (function (_super) {
            __extends(StateWrapper, _super);
            function StateWrapper(props) {
                var _this = _super.call(this, props) || this;
                _this.state = getInitialState(props);
                return _this;
            }
            StateWrapper.prototype.render = function () {
                var _this = this;
                var childProps = getProps(this.props, this.state, function (state, callback) { return _this.setState(state, callback); });
                return React.createElement(Component, __assign({}, childProps));
            };
            return StateWrapper;
        }(React.PureComponent));
        var innerName = Component.displayName || Component.name || "Component";
        ret.displayName = "MapState(" + innerName + ")";
        return ret;
    };
}
exports.mapState = mapState;



//////////////////
// WEBPACK FOOTER
// ./~/react-mapstate/dist/index.js
// module id = 2457
// module chunks = 0